import { CountUp } from '@/components/primitives/CountUp'
import { Card } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

interface Props {
  label: string
  value: number | string | null | undefined
  hint?: string
  prefix?: string
  suffix?: string
  decimals?: number
  tone?: 'default' | 'warning' | 'danger' | 'success'
  icon?: ReactNode
  className?: string
}

const TONE_CLASS = {
  default: '',
  warning: 'border-amber-500/30 bg-amber-500/5',
  danger: 'border-destructive/30 bg-destructive/5',
  success: 'border-emerald-500/30 bg-emerald-500/5'
}

export function StatCard({
  label,
  value,
  hint,
  prefix,
  suffix,
  decimals,
  tone = 'default',
  icon,
  className
}: Props) {
  const numeric = typeof value === 'number' ? value : null
  const display = value === null || value === undefined ? '—' : value

  return (
    <Card className={cn('rounded-2xl p-4', TONE_CLASS[tone], className)}>
      <div className="flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
        {icon}
        {label}
      </div>
      <div className="mt-1.5 text-2xl font-semibold tabular-nums">
        {numeric !== null ? (
          <>
            {prefix}
            <CountUp
              value={numeric}
              format={(v) =>
                decimals !== undefined
                  ? v.toLocaleString(undefined, {
                      minimumFractionDigits: decimals,
                      maximumFractionDigits: decimals
                    })
                  : Math.round(v).toLocaleString()
              }
            />
            {suffix}
          </>
        ) : (
          String(display)
        )}
      </div>
      {hint && (
        <div className="mt-1 text-[11px] text-muted-foreground">{hint}</div>
      )}
    </Card>
  )
}
